import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IRiderEntryRetry } from '../../interfaces/riderEntriesretry.interface';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { EntryPaymentsService } from '../../data-access/entryPayments.service';
import { MatButtonModule } from '@angular/material/button';
import { Subject, takeUntil } from 'rxjs';
import { IShowEntryDetailsResponse } from '../../interfaces/showEntryDetailsResponse.interface';
import { ShowEntryCheckoutComponent } from '../show-entry-checkout/show-entry-checkout.component';
import { MatListModule, MatSelectionListChange } from '@angular/material/list';

@Component({
  selector: 'equine-ui-nx-show-entry-payments',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatSelectModule,
    MatButtonModule,
    MatListModule
  ],
  templateUrl: './show-entry-payments.component.html',
  styleUrl: './show-entry-payments.component.scss',
})
export class ShowEntryPaymentsComponent implements OnInit, OnDestroy {

  private data: {userId: string, entries: IRiderEntryRetry[]} = inject(MAT_DIALOG_DATA);
  private dialog = inject(MatDialog);
  private dialogRef = inject(MatDialogRef<ShowEntryPaymentsComponent>);
  private entryPaymentsService = inject(EntryPaymentsService);

  private unsubscribe$ = new Subject<void>();

  entries = signal<IRiderEntryRetry[]>([]);

  uniqueShows = computed<{showId: string, showName: string, showStatus: string, showType: string, showMongoId: string, groupId: string | null}[]>(
    (): any => {
      const showIds: string[] = [];
      const toReturn: {showId: string, showName: string, showStatus: string, showType: string, showMongoId: string, groupId: string | null}[] = [];
      this.entries().forEach(each => {
        if (!showIds.includes(each.showMongoId)) {
          showIds.push(each.showMongoId);
          toReturn.push({showId: each.showId, showName: each.showName, showStatus: each.showStatus, showType: each.showType, showMongoId: each.showMongoId, groupId: each.groupId});
        }
      })
      return toReturn;
    }
  );

  selectedShowId = signal<string | null>(null);
  selectedGroupId = signal<string | null>(null);

  ridersEntries = computed<IRiderEntryRetry[]>((): IRiderEntryRetry[] => {
    return this.entries().filter(each => each.showMongoId === this.selectedShowId()).filter(each => !this.ordersToPay().includes(each.orderId));
  });

  ordersToPay = signal<string[]>([]);

  entriesSelected = computed<IRiderEntryRetry[]>((): IRiderEntryRetry[] => {
    return this.entries().filter(each => this.ordersToPay().includes(each.orderId));
  });

  ngOnInit(): void {
    this.entries.set(this.data.entries);
  }

  onSelectionChanged(event: MatSelectionListChange) {
    console.log('SHOW SELECTED:', event.options[0]?.value);
    this.selectedShowId.set(event.options[0]?.value.showMongoId);
    const groupId = event.options[0]?.value.groupId;
    if (!groupId || this.selectedGroupId() !== groupId) {
      this.ordersToPay.set([]);
    }
    this.selectedGroupId.set(event.options[0]?.value.groupId);
  }

  addToOrders(orderId: string) {
    this.ordersToPay.set([...this.ordersToPay(), orderId]);
  }

  removeOrder(orderId: string) {
    this.ordersToPay.set(this.ordersToPay().filter(each => each !== orderId));
  }

  payEntries() {
    if (!this.ordersToPay().length) {
      return;
    }

    this.entryPaymentsService.payShowEntries(this.ordersToPay(), this.selectedShowId() as string)
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (response: {shows: IShowEntryDetailsResponse[], greatTotal: number, products: any[]}) => {
          const dialog = this.dialog.open(ShowEntryCheckoutComponent, {
            disableClose: true,
            data: {
              entryDetails: response
            }
          });

          dialog.afterClosed()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
              next: (close: boolean) => {
                debugger
                if (close) {
                  this.dialogRef.close();
                }
              }
            });
        }
      })
  }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
